import { TableColumn, TableConfig } from '@components/data-table/data-table.component';
import { NotificationDeliveryDto } from '@app/services/user-notifications-api.service';

export function notificationJournalColumns(): TableColumn[] {
  return [
    { field: 'createAt', header: 'adminNotifications.time', type: 'date', dateTime: true, minWidth: '9rem' },
    { field: 'eventKey', header: 'adminNotifications.event', type: 'text', minWidth: '10rem' },
    { field: 'recipientUserId', header: 'adminNotifications.recipient', type: 'text', minWidth: '9rem' },
    {
      field: 'recipientEmail',
      header: 'adminNotifications.recipientEmail',
      type: 'text',
      minWidth: '12rem',
      parseFunction: (row: NotificationDeliveryDto) => row.recipientEmail?.trim() || '—',
    },
    { field: 'channelKey', header: 'adminNotifications.channel', type: 'text' },
    {
      field: 'renderedTitle',
      header: 'adminNotifications.subject',
      type: 'text',
      minWidth: '14rem',
      parseFunction: (row: NotificationDeliveryDto) => row.renderedTitle?.trim() || '—',
    },
    { field: 'outcome', header: 'adminNotifications.outcome', type: 'text' },
    {
      field: 'reason',
      header: 'adminNotifications.reason',
      type: 'text',
      minWidth: '14rem',
      parseFunction: (row: NotificationDeliveryDto) => row.reason?.trim() || '—',
    },
    { field: 'isTest', header: 'adminNotifications.testFlag', type: 'boolean' },
  ];
}

export function notificationJournalTableConfig(emptyMessage: string): TableConfig {
  return {
    paginator: true,
    rows: 20,
    keepOrder: true,
    emptyMessage,
  };
}
